import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  currentTablePage: 1,
  currentTablePageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  searchOrder: "",
  showAddDeliverySecModal: false,
  showPassword: false,
  showDeleteModal: false,
  selectedCardId: "",
  selectedRecheckCardId: "",
  selectedReissueCardId: "",
  selectedDeliverySection: "",
  isEdit: false,
  deliverySectionData: {
    Pending: [],
  },
  deliverySectionRecheckData: {
    Pending: [],
  },
  deliverySectionReissueData: {
    Pending: [],
  },
  logoPreview: "",
  deliverySectionDataStatus: "idle",
  deliveryRecheckSectionDataStatus: "idle",
  deliveryReissueSectionDataStatus: "idle",
  deliveryChallanEditStatus: "idle",
  deliveryRecheckChallanEditStatus: "idle",
  total: {
    Pending: "",
  },
  printData: "",
  printChellanData: "",
  clear: false,
  showPrintEditModal: false,
  deliveryChallanEditData: {},
  deliveryRecheckChallanEditData: {},
  deliveryReissueChallanEditData: {},
};

export const getDeliveryListData = createAsyncThunk(
  "old-certificate/delivery",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/order/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
//delivery recheck section
export const getDeliveryRecheckListData = createAsyncThunk(
  "old-certificate/delivery/recheck",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `/employee-dashboard/recheck/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getDeliveryReissueListData = createAsyncThunk(
  "old-certificate/delivery/reissue",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.post(
        `delivery/old-certificate/pending-queue`,
        params,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getDeliveryChallanEditData = createAsyncThunk(
  "old-certificate/delivery/edit",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(
        `/delivery/edit?stock_receipt_id=${params?.stock_receipt_id}`,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getDeliveryRecheckChallanEditData = createAsyncThunk(
  "old-certificate/delivery/recheck/edit",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(
        `/delivery/recheck/edit?stock_receipt_id=${params?.stock_receipt_id}`,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getDeliveryReissueChallanEditData = createAsyncThunk(
  "old-certificate/delivery/reissue/edit",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(
        `/delivery/old-certificate/edit?stock_receipt_id=${params?.stock_receipt_id}`,
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const deliveryOldCardReissueSlice = createSlice({
  name: "deliveryOldCardReissue",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: {
    [getDeliveryListData.pending]: (state) => {
      state.deliverySectionDataStatus = "pending";
    },
    [getDeliveryListData.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.deliverySectionData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });

      if (state.search != "") {
        if (state.currentPage == 1) {
          state.deliverySectionData.Pending = newData;
        } else {
          if (
            state.deliverySectionData.Pending?.length <=
            action.payload.data.data.total_count
          ) {
            state.deliverySectionData.Pending = [
              ...state.deliverySectionData.Pending,
              ...newData,
            ];
          }
        }
      } else {
        state.deliverySectionData.Pending = combinedPending;
      }
      // state.deliverySectionData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.deliverySectionDataStatus = "fulfilled";
    },
    [getDeliveryListData.rejected]: (state) => {
      state.deliverySectionDataStatus = "failed";
    },
    //recheck section
    [getDeliveryRecheckListData.pending]: (state) => {
      state.deliveryRecheckSectionDataStatus = "pending";
    },
    [getDeliveryRecheckListData.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.deliverySectionRecheckData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });
      state.deliverySectionRecheckData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.deliveryRecheckSectionDataStatus = "fulfilled";
    },
    [getDeliveryRecheckListData.rejected]: (state) => {
      state.deliverySectionDataStatus = "failed";
    },

    //reissue section
    [getDeliveryReissueListData.pending]: (state) => {
      state.deliveryReissueSectionDataStatus = "pending";
    },
    [getDeliveryReissueListData.fulfilled]: (state, action) => {
      const newData = action.payload.data.data.data;
      const uniqueItems = {};
      const combinedPending = [];
      // Add existing items with unique _id values to uniqueItems
      state.deliverySectionReissueData.Pending.forEach((item) => {
        uniqueItems[item._id] = true;
        combinedPending.push(item);
      });
      // Add new items with unique _id values to uniqueItems and combinedPending
      newData.forEach((item) => {
        if (!uniqueItems[item._id]) {
          uniqueItems[item._id] = true;
          combinedPending.push(item);
        }
      });
      state.deliverySectionReissueData.Pending = combinedPending;
      state.total.Pending = action.payload.data.data.total_count;
      state.deliveryReissueSectionDataStatus = "fulfilled";
    },
    [getDeliveryReissueListData.rejected]: (state) => {
      state.deliverySectionDataStatus = "failed";
    },

    // delivery challan edit section
    [getDeliveryChallanEditData.pending]: (state) => {
      state.deliveryChallanEditStatus = "pending";
    },
    [getDeliveryChallanEditData.fulfilled]: (state, action) => {
      state.deliveryChallanEditStatus = "fulfilled";
      state.deliveryChallanEditData = action.payload.data;
    },
    [getDeliveryChallanEditData.rejected]: (state) => {
      state.deliveryChallanEditStatus = "failed";
    },
    //delivery challan recheck edit
    [getDeliveryRecheckChallanEditData.pending]: (state) => {
      state.deliveryRecheckChallanEditStatus = "pending";
    },
    [getDeliveryRecheckChallanEditData.fulfilled]: (state, action) => {
      state.deliveryRecheckChallanEditStatus = "fulfilled";
      state.deliveryRecheckChallanEditData = action.payload.data;
    },
    [getDeliveryRecheckChallanEditData.rejected]: (state) => {
      state.deliveryRecheckChallanEditStatus = "failed";
    },
    [getDeliveryReissueChallanEditData.pending]: (state) => {
      state.deliveryChallanEditStatus = "pending"; // optional: you can have a separate status for reissue edit
    },
    [getDeliveryReissueChallanEditData.fulfilled]: (state, action) => {
      state.deliveryChallanEditStatus = "fulfilled"; // or create `deliveryReissueChallanEditStatus`
      state.deliveryReissueChallanEditData = action.payload.data; // ✅ Store the response correctly
    },
    [getDeliveryReissueChallanEditData.rejected]: (state) => {
      state.deliveryChallanEditStatus = "failed";
    },
  },
});

export const { updateConfig, resetConfig } = deliveryOldCardReissueSlice.actions;

export default deliveryOldCardReissueSlice.reducer;
